/**
 * FormSection
 */
export const FormSection: React.FC<React.BaseHTMLAttributes<HTMLDivElement>> = ({ className, ...props }) => (
  <div className={cxm("flex flex-col gap-6", className)} {...props} />
)
